import laravelRoute from 'ziggyRoute';
import { clientApi } from '@phoenix/clientApi';
import { createI18n } from 'vue-i18n';
import { capitalize, get, isNil } from 'lodash-es';

const i18n = () => {
  const fallbackLocales = [Phoenix.laravelLanguage, 'en'];

  const messageResolver = (messages, id) => {
    id = id.toLowerCase();
    const message = messages[id];
    return isNil(message) ? null : message;
  };

  const missingHandler = async (locale, id) => {
    id = id.toLowerCase();

    for (const fallbackLocale of fallbackLocales) {
      const message = messageResolver(i18n.global.getLocaleMessage(fallbackLocale), id);
      if (message !== null && message.toLowerCase() !== id) {
        return message;
      }
    }

    if (navigator.userAgent === 'Cypress') {
      // If we change the text, the modalSignUp test fails because we loose the modal trigger event
      const EXCEPTIONS_IDS = ['checkout.register', 'checkout.login'];

      if (EXCEPTIONS_IDS.includes(id)) {
        return capitalize(id);
      }

      const rand = Math.floor(Math.random() * 100000);
      return `test-key-${rand}`;
    }

    // set the value with the id, so the call will be done once
    i18n.global.mergeLocaleMessage(locale, { [id]: id });

    try {
      const { data } = await clientApi.post(laravelRoute('api.translations.js.activate', { id }), {
        locale,
        pageId: Phoenix.pageId,
      });

      const newValues = get(data, ['data', 'values'], {});

      for (const [key, value] of Object.entries(newValues)) {
        i18n.global.mergeLocaleMessage(key, { [id]: value });
      }

      return get(newValues, locale);
    } catch (e) {
      console.warn(`[TRANSLATION ERROR]: ${e.response.data.message}`);
    }

    return id;
  };

  const i18n = createI18n({
    locale: Phoenix.laravelLocale,
    messages: Phoenix.translations,
    messageResolver,
    missing: missingHandler,
    fallbackWarn: false,
    fallbackLocale: fallbackLocales,
  });

  Phoenix.i18n = i18n.global;

  return i18n;
};

export default i18n();
